import convertTimestampToShamsi from '@/common/utils/convertTimestampToShamsi';
import {
  DriverInfoType,
  DriverInfoTypeParams,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDriverInfo/driverInfoQuery.type';
import { driverInfoQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDriverInfo/driverInfoQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const driverInfoQueryOptions = (params: DriverInfoTypeParams) =>
  queryOptions({
    queryKey: ['get_driver_info', params],
    queryFn: () => driverInfoQueryFunction(params),
    select: (data: DriverInfoType) => {
      return {
        ...data,
        personal_information: {
          ...data.personal_information,
          birthdate: data?.personal_information?.birthdate
            ? convertTimestampToShamsi(
                Number(data?.personal_information?.birthdate),
              )
            : null,
          gender: data?.personal_information?.gender?.const,
          is_owner_driver:
            data?.personal_information?.is_owner_driver === true
              ? 'true'
              : 'false',
          driver_iranian:
            data?.personal_information?.driver_iranian === true
              ? 'true'
              : 'false',
        },
        certificate_information: {
          ...data.certificate_information,
          license_type: {
            label: data?.certificate_information?.license_type?.fa_name,
            value: data?.certificate_information?.license_type?.id,
          },
          license_issue_date: data?.certificate_information?.license_issue_date
            ? convertTimestampToShamsi(
                Number(data?.certificate_information?.license_issue_date),
              )
            : null,
          license_issue_location_country: {
            label:
              data?.certificate_information?.license_issue_location_country
                ?.name,
            value:
              data?.certificate_information?.license_issue_location_country?.id,
          },
        },
      };
    },
  });
